import { useEffect, useState } from 'react';
import { MdLogout, MdEmail } from "react-icons/md";
import ImageElement from '../../Common/ImageElement';
import { appImages } from '../../constants';
import { useNavigate } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { MdTask } from 'react-icons/md';

const MenuItem = ({ item, navigateLink }) => {
    const isChild = item?.submenu?.length > 0;
    const currentPath = window.location.pathname;
    
    // For parent items, check if current path exactly matches the link or starts with it
    const isTabActive = isChild 
        ? currentPath === item.link || currentPath.startsWith(item.link + '/')
        : currentPath === item.link;

    const toggleMenu = (redirectLink, link) => {
        if(redirectLink?.includes("/logout")){
            localStorage.clear();
            window.location.reload();
        } else {
            const ele = document.querySelector(`#${String(link || redirectLink).replace("/", "")}`);
            if (ele) ele.scrollIntoView({ behavior: "smooth" });
            navigateLink(redirectLink);
        }
    }

    return (
        <div className={`menu-item ${isTabActive ? 'active' : ''}`}>
            <div className="menu-title" id={String(item?.link).replace("/", "")} onClick={() => toggleMenu(item.link)}>
                <span className="menu-icon">{item.icon}</span>
                
                {item.link === '/logout' && item.email ? (
                    <div className="email-section">
                        <p className="mb-0">{item.title}</p>
                        <div>
                            <MdEmail size={15} style={{ color: '#6c757d' }} />
                            <span style={{
                                color: '#495057',
                                fontWeight: '500',
                                letterSpacing: '0.2px'
                            }}>{item.email}</span>
                        </div>
                    </div>
                ) : <span className="menu-text">{item.title}</span>}
            </div>
            {isChild && <div className={`submenu open`}>
                {item.submenu.map((subItem, index) => {
                    const link = `${item.link}${subItem.link ?? ""}`
                    // For submenu items, use exact path matching
                    const isActive = currentPath === link;
                    return <div key={index} onClick={() => toggleMenu(link, item?.link)} className={`submenu-item d-flex justify-content-start align-items-center ${isActive ? 'active' : ''}`}>
                        <div className='submenu-title w-100'>
                            <span className="menu-icon">{subItem?.icon ?? <></>}</span>{subItem.title}
                        </div>
                    </div>
                })}
            </div>}
        </div>
    );
};

const AsideMenu = ({ showMenu }) => {
    const [menu, setMenu] = useState([]);
    const [openMenus, setOpenMenus] = useState({});
    const navigate = useNavigate();
    // we set allowedPageNames in redux store in Login.js
    const userDetails = useSelector(state => state.userDetails, shallowEqual);
    const { data: userData, allowedPageNames } = userDetails || {};

    const toggleSubmenu = (index, link = null) => {
        if(link) navigate(link);
        setOpenMenus({ [index]: !openMenus[index] });
    };

    useEffect(() => {
        setMenu(allowedPageNames);
    }, [allowedPageNames]);

    return (
        <aside className="aside-menu" style={{ width: showMenu ? "280px" : "0px" }}>
            <div className='upper-menu'>
                <div className="logo mt-4">
                    <ImageElement src={appImages.logo} alt="login-log" />
                </div>
                <div className="menu-container">
                    {menu.map((item, index) => (
                        <MenuItem
                            key={index}
                            item={item}
                            isOpen={openMenus[index]}
                            navigateLink={(link) => navigate(link)}
                            toggleSubmenu={(link) => toggleSubmenu(index, link)}
                        />
                    ))}
                </div>
            </div>
            <div className='aside-footer'>
                <MenuItem
                    item={{
                        title: 'Log Out',
                        icon: <MdLogout size={20} />,
                        link: '/logout',
                        email: userData?.email
                    }}
                />
            </div>
        </aside>
    );
};

export default AsideMenu;